import banner from '../../images/login-banner.png';
import styles from './index.module.css';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <p className={styles.sectionBody}>{children}</p>
    </div>
  );
}

function PrivacyPolicy() {
  return (
    <div className={styles.page}>
      <div className={styles.brandBar}>
        <img src={banner} alt="Joyya" className={styles.brandLogo} />
      </div>
      <div className={styles.content}>
        <div className={styles.doc}>
          <h1 className={styles.docTitle}>Joyya Privacy Policy</h1>
          <p className={styles.docSubtitle}>
            This privacy policy explains how we handle any information collected when you use Joyya.
          </p>
          <hr className={styles.divider} />

          <Section title="Identity and Access">
            When you sign up for a Joyya product, we ask for identifying information such as your
            name and email address. This is so you can personalize your account and we can send you
            essential updates. We never sell your personal information to third parties.
          </Section>

          <Section title="Product Interactions">
            We store on our servers the content that you upload, receive, or maintain in your Joyya
            product accounts to ensure your data is available across your devices.
          </Section>

          <Section title="Location of Data">
            Joyya is a company operating in India. Our products and data infrastructure are managed
            and operated primarily within India and compliant regions.
          </Section>

          <Section title="Your Rights">
            Regardless of your location, we provide the Right to Know, Right of Access, Right to
            Correction, and the Right to Erasure ('To Be Forgotten'). You can exercise these rights
            by contacting us.
          </Section>

          <div className={styles.contact}>
            <p className={styles.contactLabel}>Questions?</p>
            <a href="mailto:sandy.watt@joyya.com" className={styles.contactLink}>
              sandy.watt@joyya.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PrivacyPolicy };
